import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The exciting future Javascript",
  "description": "",
  "published": "2012-04-02T00:00:00.000Z",
  "redirect_from": ["/blog/the-exciting-future-javascript/swizec/4101"],
  "categories": "Constructor (object-oriented programming), Definition, Douglas Crockford, ECMAScript, Function object, functions, JavaScript, Scope (computer science), Uncategorized",
  "hero": "./img/4073-4766782412_f471ddd85e_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.ecma-international.org/publications/standards/Ecma-262.htm",
        "title": "ECMAScript"
      }}>{`ECMAscript`}</a>{`, 6th edition might bring us fat arrow notation - `}<a parentName="p" {...{
        "href": "http://www.yuiblog.com/blog/2012/03/30/what-is-the-meaning-of-this"
      }}>{`Douglas Crockford on fat arrows`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function (x) {
    return x * x;
}

// becomes

(x) => x * x
`}</code></pre>
    <p>{`Douglas' post concerns itself mostly with the intricacies of how `}<em parentName="p">{`this`}</em>{` is bound to the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Function_object",
        "title": "Function object"
      }}>{`function object`}</a>{`and what the fat arrow notation might bring, what I see is something completely different.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "240px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/182539dae9508b14687996c31a1e9c63/09b79/4073-4766782412_f471ddd85e_m.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2030v31l4%201%2011%204%201%201%205%201a17796%2017796%200%200132%2012l5%202-1%205a275%20275%200%2001-3%2024%20294%20294%200%2001-7%2031c1-8-1-10-7-10l-5-1c-2-1-7%200-8%202-3%208-3%2010-2%2011v1c-5%200%206%205%2013%205l5%201%202%201c1%200%202%201%201%202l-1%202-1%201c-2%202-6%200-5-2%200-2-2-3-5-3-9-1-10-3-11-9l-3-6c-2-1-2-3-2-10a61%2061%200%2000-2-13l-3-4-1-4c0-2%200-3-1-1l-2%202-2-1v-1c0-2-3-4-5-4s-2%208-2%2076v77h4c3%200%205%200%206%202l3%203-7-1-6%201c0%201%201%202%203%202l2%201-2%201H0v37h277l2-3%201-21v-19h3l3%201%201%2011v12l4-3c6-6%2016-8%2022-5%202%201-2%203-7%203-3-1-5%202-4%208v3l-2-3c-3-3-5-3-3%200l-1%201-5%205-4%207-1%202%2057%201h58V100l-3-1-7-3c-4%200-5-1-4-2h7l5%201c1%201%201-1%201-9V75l-3%202c-8%204-13%208-13%2010%201%202-3%205-5%205l-1%201-1%202c-2%201-3-1-2-3%200-2-1-3-5-4-6%200-7-1-8-2l5-1c6%201%2014-3%2012-5l3-3%2011-5%207-3v-7l1-34V0h-3l-4%201-5%203-11%207-31%2016c-3%200-11%205-12%207s-2%203-3%202c-2-1-5%203-4%206l1%204a220%20220%200%200025-16l11-5a171%20171%200%200115-9l7-4%201-1%206-4%206-3v6c0%207-1%2011-2%2011l-4%202-5%202c-1%200-3%200-4%202l-4%203a672%20672%200%2000-42%2022l-8%204-3-3-4-7c-1-4-2-4-4-4-4%201-4%201-3%204%201%204%203%205%202%201v-3l2%201c2%203%203%205%201%205-3%200-2%202%200%205%202%202%202%203%201%204l-1-1c-1-4-3-3-3%201l-2%204-4%203c-8%205-16%208-20%207l-5-2-6-2c-7-1-9%200-10%205%200%204%200%204%203%203%203-2%2017-2%2016%200l2%201%208%202a2649%202649%200%200049%2018c-4%201-10%202-12%201-5-3-7-3-9-3l-6-1-4-2-21-6-6-2-6-2-9-2-9-3c-1-2-3-3-2-1%201%201-5%202-8%202s5-5%207-5l4-4%205-3%202-2%202-2%201%201c-1%202%201%204%202%202v-2l-1-2-1-2-2-1-6-1-6-1v3c1%204-1%205-5%204-1-1-1-1%201-3s2-2%201-3l-2-2c1-1%201-1-1-1l-2%201%201%202h-3c-2%200-3-2-1-2%203%200%208-7%207-9l-1-6v-4l6%202%207%203%205%202%205%201c0%201-4%207-6%207v3c2%202%205%200%205-2-1-1%203-7%206-10%202-1-2-5-7-5l-5-3h-3c-2%200-12-4-12-6l21-6c9-2%2013-2%2012%200-1%201%203%203%204%202v-1c-1%200-2%200-1-1l-1-2v-1c4%200%2014%2012%2011%2012l-4%201-3%201-4%202-4%203c-1%201-1%201%202%201l5-1a73%2073%200%200117-6l1-2-1-4-4-3-4-5c-2-2-1-2%2019-7%205-2%208-4%207-6l-11%203-15%203c-4%200-4%200-4-3l1-4V1L152%200H0v30M351%201l-6%202c-8%202-10%203-9%204%200%202%204%202%207%200s5-1%206%203a910%20910%200%20011%205h3l2-1-1-1-2-4c0-4%203-6%208-6l4-2c2-1%202-1-5-1l-8%201m-68%209l-2%204c0%203-10%206-22%207l-9%201%203%202%203%202%208-2a898%20898%200%200126-9c-2%200-3%200-2-1l-3-6-2%202m44%2021l-4%201-2%201%202%201h1l-3%201-3%201-4%201-2%201-5%204c-4%203-5%203-7%202-5-1-6-1-8%201s-2%203%200%203c3%200%200%203-4%206l-5%203-1%201-2%201%202%201%202-1%201-1%2014-9%203-2%206-3c7-4%2014-7%2016-6l2-2c1-3%202-3%205-3l1-1c0-2-4-3-5-1M71%2039c-2%206-1%2010%201%2011l3%202h-3c-4%200-2%202%205%206l6%203%2011%206%207%204h3l-2-3c-2-2%200-1%203%201l3%202-2%201c-2%200-2%200%202%203l9%205%209%205%2020%2010v-1c0-2%202-3%203-1l-1%201c-2%200-1%202%205%205%205%203%208%203%204%200l-2-2%203%201c3%200%203%200%204-3%200-4%202-4%204-1l8%206%2010%206%205%203%202%201c1%201%202%202%203%201%202%200%202%200%201%201v1c1-1%203%200%205%202l4%202%202%201%202%202c1-1%205%202%207%204l4%202a37%2037%200%20019%206c4%203-1%203-7-1l-9-5-4-2-1-1-10-5a719%20719%200%2000-36-18l-1%2015a1896%201896%200%2001-92-45%206340%206340%200%2000-23%20175l6%201c6%201%207%201%208%204%201%202%201%202%201-2a63%2063%200%20011-9c0-2%203-6%2010-11%205-5%208-6%2015-7s13%201%2016%206c3%203%206%2015%205%2017l-1%204c0%202%201%202%2013%203l112%204h4l1-49c0-59%200-67-4-69l-2-2h4c1%201%201%200%201-3%200-4%200-4-3-3l-2-1-1-3h-6v-2c2%200-10-8-15-10l-3-2-1-1-2%201-1%201-1-2c0-2-3-4-22-16-24-14-27-16-23-12%202%203%200%203-4-1l-4-2%203%201c5%200%204%200-4-5s-10-5-4%200c6%204%203%204-4%200-5-4-5-4-2-4%202%200%202-1-2-3-3-2-5-3-6-2l1%201c2%200%204%203%204%204l-11-6a669%20669%200%2000-51-26m295%2055l-7%201-6%201%2015%201h3l-10%205c-4%201-5%202-3%203s7%200%2015-4l5-4h-3c-1%201-4-1-4-3s-2-2-5%200m-46%2018h1l5%201%203%202-3%201c-6%202-8%203-8%205s2%202%203%200c2-2%206-1%206%201l1%202%201-2c-1-4%200-4%207-6l4-3-20-1m33%209a864%20864%200%2000-46%2018c2%201%205%200%2041-12a216%20216%200%200011-4c3-1%204-2%201-3l-1-1-6%202m-73%2083v38l3-4%203-5v-31c-1-33-1-36-4-36-2%200-2%201-2%2038M14%20260l-4%201c-8%202-3%203%2010%204l28%201c17%201%2018%200%2014-4-1-2-3-2-25-2H14m166%202h-40l-37%201c-2%203%200%204%2017%204a14466%2014466%200%200164%200h16v-2c0-2-1-2-7-2l-6-1h-7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/182539dae9508b14687996c31a1e9c63/ca0a1/4073-4766782412_f471ddd85e_m.webp 223w", "/static/182539dae9508b14687996c31a1e9c63/8ac56/4073-4766782412_f471ddd85e_m.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/182539dae9508b14687996c31a1e9c63/853b2/4073-4766782412_f471ddd85e_m.jpg 223w", "/static/182539dae9508b14687996c31a1e9c63/09b79/4073-4766782412_f471ddd85e_m.jpg 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/182539dae9508b14687996c31a1e9c63/09b79/4073-4766782412_f471ddd85e_m.jpg",
                "alt": "vim",
                "title": "vim",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`vim`}</figcaption>{`
  `}</figure></p>
    <p>{`Proper lambdas!`}</p>
    <p>{`That's right, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Function_%28mathematics%29",
        "title": "Function (mathematics)"
      }}>{`functions`}</a>{` that implicitly return with none of that big ugly `}<em parentName="p">{`function`}</em>{` keyword! Hooray.`}</p>
    <p>{`A bit tricky when you need a named function, but so far this is just an unofficial proposal, I'm sure they'll figure something out by the time ECMA6 comes anywhere near being a standard (not in 2012).`}</p>
    <p>{`As I said on hacker news `}<em parentName="p"><a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/JavaScript",
          "title": "JavaScript"
        }}>{`Javascript`}</a>{` is a beautiful language, trapped in bad syntax, peppered with poor semantic choices`}</em>{`. What is left of a language once you take syntax and semantics out of the picture? Quite a lot.`}</p>
    <h2 {...{
      "id": "what-else-is-new"
    }}>{`What else is new`}</h2>
    <p>{`Spurred on by excitement I decided to poke around the `}<a parentName="p" {...{
        "href": "http://wiki.ecmascript.org/doku.php"
      }}>{`wiki for the ongoing specification work of Ecma`}</a>{`.`}</p>
    <p>{`Some of the "`}<a parentName="p" {...{
        "href": "http://wiki.ecmascript.org/doku.php?id=harmony:harmony"
      }}>{`tentatively approved`}</a>{`" proposals include:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p"><a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:array_comprehensions"
            }}>{`Array comprehensions`}</a>{` and `}<a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:generator_expressions"
            }}>{`generators`}</a>{` and `}<a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:iterators"
            }}>{`iterators`}</a></strong>{` - a natural notation for constructing lists from lists, used a lot in python and haskell.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-javascript"
          }}>{`// mapping
[ square(x) for (x of [1,2,3,4,5]) ]
// filtering
[ x for (x of a) if (x.color === ‘blue’) ]
`}</code></pre>
        <p parentName="li">{`This naturally extends into generators, where you can have an object generating values according to a pattern - possibly until infinity. (the example given in the proposal are fibonacci numbers, obviously)`}</p>
      </li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Iterator",
        "title": "Iterator"
      }}>{`Iterators`}</a>{` are a similar beast - you get to define `}<em parentName="p">{`how`}</em>{` an object should be iterated over, which gives us nice abstractions for all sorts of things.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p"><a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:classes"
            }}>{`Classes`}</a>{` `}</strong>{`- although using prototypes, functions and instances is enough to do everything classes can do, it isn't very expressive and too much deep knowledge is required to understand the code.`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`A class defines four objects and their properties: a `}<a parentName="p" {...{
              "href": "http://en.wikipedia.org/wiki/Constructor_%28object-oriented_programming%29",
              "title": "Constructor (object-oriented programming)"
            }}>{`constructor function`}</a>{`, a prototype, a new instance, and a private record bound to the new instance. The body of a class is a collection of member `}<a parentName="p" {...{
              "href": "http://en.wikipedia.org/wiki/Definition",
              "title": "Definition"
            }}>{`definitions`}</a>{`.`}</p>
        </blockquote>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p"><a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:block_scoped_bindings"
            }}>{`Block scoped bindings`}</a></strong>{` - Javascript used to only be `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Scope_%28computer_science%29",
            "title": "Scope (computer science)"
          }}>{`lexically scoped`}</a>{`, otherwise known to new programmers as `}<em parentName="p">{`"Aaaaaah everything is global what the hell!?"`}</em>{`. With the addition of `}<a parentName="p" {...{
            "href": "http://wiki.ecmascript.org/doku.php?id=harmony:let"
          }}>{`let`}</a>{`, `}<a parentName="p" {...{
            "href": "http://wiki.ecmascript.org/doku.php?id=harmony:const"
          }}>{`const`}</a>{` and block functions there will now also be block scope where you can define things to only exist inside two {}.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p"><a parentName="strong" {...{
              "href": "http://wiki.ecmascript.org/doku.php?id=harmony:modules"
            }}>{`Modules!`}</a></strong></p>
      </li>
    </ol>
    <p>{`What has traditionally been solved using require.js will now work similar to how python does it. You get to define modules and then import them where they are needed. Possibly the most earth shattering addition since dependency management in Javascript has devolved into an extreme sport lately.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// module
module math {
    export function sum(x, y) {
        return x + y;
    }
    export var pi = 3.141593;
}

// client
// we can import in script code, not just inside a module
import {sum, pi} from math;

alert("2π = " + sum(pi, pi));
`}</code></pre>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol"><strong parentName="li"><a parentName="strong" {...{
            "href": "http://wiki.ecmascript.org/doku.php?id=harmony:direct_proxies"
          }}>{`Proxies`}</a></strong>{` - according to the proposal a `}<em parentName="li">{`Proxy`}</em>{` is an object that takes two objects - a target and a handler. Where, if I understand correctly, you call functions on the proxy (trigger them), which execute as traps on the handler object, using the target.`}</li>
    </ol>
    <p>{`This looks like a new way of handling events.Similar to what modern MVC frameworks are doing where you have a "view" that takes care of safely executing functions when events are triggered.`}</p>
    <h2 {...{
      "id": "when"
    }}>{`When?`}</h2>
    <p>{`A lot more interesting stuff can be found in the `}<a parentName="p" {...{
        "href": "http://wiki.ecmascript.org/doku.php?id=strawman:strawman"
      }}>{`strawman section`}</a>{` where completely far out ideas live, but the tentatively approved ideas already raise my hopes far too much without any assurance I'll ever get any of this. So much could change before any of this is solidifies into a standard.`}</p>
    <p>{`And even when it does become a standard ... how long before any of this reaches wide browser support? Mozilla's Javascript already includes a lot of this stuff - a lot of the proposals come from there actually - anyone else? Not really.`}</p>
    <p>{`At least there is some comfort in the fact all of this will quickly reach node.js :)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.chromium.org/2012/02/future-of-javascript-take-peek-today.html"
        }}>{`The Future of JavaScript - take a peek today!`}</a>{` (chromium.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://webdev360.com/the-next-javascript-in-google-chrome-40849.html"
        }}>{`The next JavaScript in Google Chrome`}</a>{` (webdev360.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://briancray.com/2012/02/23/javascript-module-pattern/"
        }}>{`Javascript module pattern: When to use it and why`}</a>{` (briancray.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/closure-and-currying-magic-for-cleaner-javascript/swizec/3981"
        }}>{`Closure and currying magic for cleaner javascript`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.davidflanagan.com/2011/11/why-i-want-clas.html"
        }}>{`Why I want Classes in JavaScript`}</a>{` (davidflanagan.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://devblog.blackberry.com/2011/08/virtual-functions-in-javascript/"
        }}>{`"Virtual" Functions in JavaScript`}</a>{` (devblog.blackberry.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lostechies.com/derekgreer/2012/02/17/javascript-closures-explained/"
        }}>{`JavaScript Closures Explained`}</a>{` (lostechies.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=234dfc5e-ee3f-4fe3-87a1-53fe9bbda4ef",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      